import React, { useState, useEffect, useMemo } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';
import EditUserPage from "./AdminEditUser";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import Swal from "sweetalert2";
import LinearProgress from "@mui/material/LinearProgress";

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../Pages/Home/CustomNoRowsOverlay";

const UserManagementPage = () => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");

    const [viewUser, setViewUser] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showDeleteUserModal, setShowDeleteUserModal] = useState(false);

    const [userToDelete, setUserToDelete] = useState(null);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    // const [usersPerPage] = useState(10); // Number of users per page
    const [visiblePages, setVisiblePages] = useState([1, 2]);

    const navigate = useNavigate();

    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const [totalRows, setTotalRows] = useState(0);

    const totalPages = Math.ceil(totalRows / paginationModel.pageSize);

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setPaginationModel((prev) => ({ ...prev, page: newPage }));
        }
    };

    useEffect(() => {
        fetchAllUser();
    }, []);

    const fetchAllUser = async () => {
        setLoading(true);
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllUserData",
        });

        const output = response.data;

        if (output.length > 0) {
            // (output);
            const modifiedOutput = output.map((row, index) => ({
                ...row,
                id: row.pk_user_key,
                s_no: index + 1,
            }));
            setTotalRows(modifiedOutput.length);
            setUsers(modifiedOutput);
        }
        setLoading(false);
    };

    const handleUserSave = (user) => {
        // Implement save logic
        console.log("User saved:", user);
        setSelectedUser(null);
    };

    const handleUserDelete = (userId) => {
        // Implement delete logic
        setUsers(users.filter((user) => user.id !== userId));
        setShowDeleteUserModal(false);
    };

    const handleViewDetails = (user) => {
        setViewUser(user);
        setShowViewModal(true);
    };

    const handleDeleteUser = (user) => {
        setUserToDelete(user);
        setShowDeleteUserModal(true);
    };

    const handleDelete = async (pk_user_key) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it",
            });

            if (result.isConfirmed) {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "deleteUserData",
                    pk_user_key: pk_user_key,
                });

                const output = response.data;

                if (output == 1) {
                    await Swal.fire("Deleted!", "The User has been successfully removed.", "success");
                    fetchAllUser();
                }
            }
        } catch (error) {
            // Handle any errors here
            console.error("An error occurred: ", error);
        }
    };

    const filteredUsers = useMemo(() => {
        const filtered = users.filter((user) => {
            return (
                (user.user_name && user.user_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (user.first_name && user.first_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (user.last_name && user.last_name.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        });

        // Update totalRows with the number of filtered rows
        setTotalRows(filtered.length);

        return filtered;
    }, [users, searchTerm]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
    };

    const capitalizeFirstLetter = (str) => {
        if (!str) return str; // If the string is empty, return as is
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    const columns = [
        {
            headerName: "S.No",
            field: "s_no", // You can use any key from your user data
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
            filterable: false, // This column is not filterable
        },
        {
            headerName: "Username",
            field: "user_name",
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
        },
        {
            headerName: "Full Name",
            field: "full_name", // You might need to concatenate first and last name in the `cellRenderer`
            headerClassName: "super-app-theme--header",
            minWidth: 250,
            flex: 2,
            renderCell: (params) => `${params.row.first_name} ${params.row.last_name}`, // Concatenate first name and last name
        },
        {
            headerName: "User Group",
            field: "user_type", // Assume this is a numeric value where 1 is Admin, 2 is Editor, 3 is Member
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => {
                switch (params.row.user_type) {
                    case 1:
                        return "Admin";
                    case 2:
                        return "Editor";
                    case 3:
                        return "Member";
                    default:
                        return "Unknown";
                }
            },
        },
        {
            headerName: "Downline Members",
            field: "user_sub_count",
            headerClassName: "super-app-theme--header",
            minWidth: 180,
            flex: 1,
        },
        {
            headerName: "Email",
            field: "user_email",
            headerClassName: "super-app-theme--header",
            minWidth: 200,
            flex: 1,
        },
        {
            headerName: "Subscription Status",
            field: "subscription_status",
            headerClassName: "super-app-theme--header",
            minWidth: 180,
            flex: 1,
            renderCell: (params) => capitalizeFirstLetter(params.row.subscription_status),
        },
        {
            headerName: "Renewable Date",
            field: "renewable_date",
            headerClassName: "super-app-theme--header",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => (params.row.subscription_status === "yes" ? formatDate(params.row.renewable_date) : "NA"),
        },
        {
            headerName: "Actions",
            field: "actions",
            type: "actions",
            headerClassName: "super-app-theme--header",
            minWidth: 200,
            cellClassName: "actions",
            getActions: ({ id, row }) => {
                return [
                    <div className="d-flex flex-row justify-content-start">
                        <Button
                            as={Link}
                            to={`/admin/user/edit/${row.pk_user_key}`}
                            className="edit-icon btn btn-outline-dark me-2"
                            data-bs-toggle="tooltip"
                            title="Edit"
                        >
                            <i className="fa-solid fa-pen-to-square"></i>
                        </Button>
                        <Button onClick={() => handleDelete(row.pk_user_key)} className="btn btn-outline-danger me-2" data-bs-toggle="tooltip" title="Delete">
                            <i className="fa-solid fa-trash"></i>
                        </Button>
                        <Button onClick={() => handleViewDetails(row)} className="btn btn-outline-info me-2" data-bs-toggle="tooltip" title="View">
                            <i className="fa-solid fa-eye"></i>
                        </Button>
                    </div>,
                ];
            },
        },
    ];

    return (
        <div className="container mt-4">
            <div className="header-user d-flex justify-content-between align-items-center mb-3 admin-page-head">
                <h4 className="mb-0">User Management</h4>
                <Button as={Link} to="/admin/user/adduser" className="btn btn-dark">
                    Add User
                </Button>
            </div>
            <div className="mb-4">
                <Form>
                    <div className="row">
                        <div className="col-md-4">
                            <Form.Group>
                                <Form.Control type="text" placeholder="Search by name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </Form.Group>
                        </div>
                    </div>
                </Form>
            </div>

            <Box
                sx={{
                    height: "fit-content",
                    width: "100%",
                    "& .MuiDataGrid-root": {
                        borderRadius: "0px",
                        margin: "0px",
                    },
                    "& .actions": {
                        color: "text.secondary",
                    },
                    "& .textPrimary": {
                        color: "text.primary",
                    },
                    "& .super-app-theme--header": {
                        fontSize: "14px",
                        fontWeight: "900",
                        // backgroundColor: "#e3e6ee",
                        backgroundColor: "#212529",
                        color: "#effcff",
                    },
                    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus":
                        {
                            outline: "none !important",
                        },

                    "& .MuiDataGrid-footerContainer": {
                        display: "none",
                    },
                    "& .MuiDataGrid-sortIcon": {
                        opacity: 1,
                        color: "white",
                    },
                    "& .MuiDataGrid-menuIconButton": {
                        opacity: 1,
                        color: "white",
                    },
                }}
                style={{
                    height: "max-content",
                    width: "100%",
                }}
            >
                <DataGrid
                    autoHeight
                    disableColumnSorting
                    // disableColumnFilter
                    headerHeight={60}
                    getRowHeight={() => "auto"}
                    // getEstimatedRowHeight={() => 50}
                    headerBorderRadius={0}
                    sx={{
                        border: "none",
                        m: 2,
                        "--DataGrid-overlayHeight": "500px",
                        fontFamily: "Roboto Serif, serif",

                        [`& .MuiDataGrid-cell`]: {
                            paddingTop: 1.5,
                            paddingBottom: 1.5,
                            lineHeight: "unset !important",
                            maxHeight: "none !important",
                            whiteSpace: "normal",
                        },
                        [`& .MuiDataGrid-columnHeader`]: {
                            [`& .MuiDataGrid-menuIcon`]: {
                                display: "none",
                            },
                        },
                        [`& .MuiDataGrid-columnHeaderTitle`]: {
                            fontWeight: "700 !important",
                        },
                    }}
                    pageSizeOptions={[10, 25, 50]}
                    paginationModel={paginationModel}
                    pagination
                    loading={loading}
                    slots={{
                        loadingOverlay: LinearProgress,
                        noRowsOverlay: CustomNoRowsOverlay,
                    }}
                    // rows={[]}
                    rows={filteredUsers}
                    columns={columns}
                    editMode="row"
                />
            </Box>

            <div className="pagination d-flex justify-content-end mb-3 my-3">
                <Button disabled={paginationModel.page === 0} onClick={() => handlePageChange(0)} className="btn btn-light mx-1">
                    &lt;&lt;
                </Button>
                <Button disabled={paginationModel.page === 0} onClick={() => handlePageChange(paginationModel.page - 1)} className="btn btn-light mx-1">
                    &lt;
                </Button>

                {Array.from({ length: totalPages }, (_, index) => {
                    // Logic to display only 3 page numbers centered around the current page
                    let startPage = Math.max(paginationModel.page - 1, 0); // Start at one page before the current page
                    let endPage = Math.min(paginationModel.page + 1, totalPages - 1); // End at one page after the current page

                    // Ensure 3 pages are shown when possible
                    if (paginationModel.page === 0) {
                        endPage = 2; // First three pages
                    } else if (paginationModel.page === totalPages - 1) {
                        startPage = totalPages - 3; // Last three pages
                    }

                    // Only show the buttons within the range
                    if (index >= startPage && index <= endPage) {
                        return (
                            <Button
                                key={index}
                                onClick={() => handlePageChange(index)}
                                className={`mx-1 ${paginationModel.page === index ? "btn-dark text-white" : "btn-light"}`}
                            >
                                {index + 1}
                            </Button>
                        );
                    } else {
                        return null; // Don't render other page numbers
                    }
                })}
                <Button
                    disabled={paginationModel.page >= totalPages - 1}
                    onClick={() => handlePageChange(paginationModel.page + 1)}
                    className="btn btn-light mx-1"
                >
                    &gt;
                </Button>
                <Button disabled={paginationModel.page >= totalPages - 1} onClick={() => handlePageChange(totalPages - 1)} className="btn btn-light mx-1">
                    &gt;&gt;
                </Button>
            </div>

            {/* User Form */}
            {selectedUser && (
                <div className="mt-4">
                    <h3>{selectedUser.id ? "Edit User" : "Add User"}</h3>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleUserSave(selectedUser);
                        }}
                    >
                        <div className="mb-3">
                            <label className="form-label">Username</label>
                            <input
                                type="text"
                                className="form-control"
                                value={selectedUser.username || ""}
                                onChange={(e) => setSelectedUser({ ...selectedUser, username: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Full Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={selectedUser.fullname || ""}
                                onChange={(e) => setSelectedUser({ ...selectedUser, fullname: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                                type="email"
                                className="form-control"
                                value={selectedUser.email || ""}
                                onChange={(e) => setSelectedUser({ ...selectedUser, email: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">User Group</label>
                            <select
                                className="form-select"
                                value={selectedUser.usergroup || ""}
                                onChange={(e) =>
                                    setSelectedUser({
                                        ...selectedUser,
                                        usergroup: e.target.value,
                                    })
                                }
                            >
                                {roles.map((role) => (
                                    <option key={role.id} value={role.name}>
                                        {role.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label htmlFor="" className="form-label">
                                Downline Member
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                value={selectedUser.downlineCount || " "}
                                onChange={(e) =>
                                    setSelectedUser({
                                        ...selectedUser,
                                        downlineCount: e.target.value,
                                    })
                                }
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Status</label>
                            <select
                                className="form-select"
                                value={selectedUser.status || ""}
                                onChange={(e) => setSelectedUser({ ...selectedUser, status: e.target.value })}
                            >
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                            </select>
                        </div>
                        <button type="submit" className="btn btn-primary">
                            Save
                        </button>
                        <Button type="button" className="btn btn-secondary ms-2" onClick={() => setSelectedUser(null)}>
                            Cancel
                        </Button>
                    </form>
                </div>
            )}

            {/* View User Details Modal */}
            {viewUser && (
                <Modal show={showViewModal} onHide={() => setShowViewModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>User Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            <strong>Username:</strong> {viewUser.user_name}
                        </p>
                        <p>
                            <strong>Full Name:</strong> {viewUser.first_name + " " + viewUser.last_name}
                        </p>
                        <p>
                            <strong>Email:</strong> {viewUser.user_email}
                        </p>
                        <p>
                            <strong>User Group:</strong>{" "}
                            {viewUser.user_type === 1 ? "Admin" : viewUser.user_type === 2 ? "Editor" : viewUser.user_type === 3 ? "Member" : "Unknown"}
                        </p>
                        <p>
                            <strong>Downline Member:</strong> {viewUser.user_sub_count}
                        </p>
                        <p>
                            <strong>Status:</strong> {viewUser.status}
                        </p>
                        <p>
                            <strong>Date:</strong> {viewUser.date}
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowViewModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* Delete User Modal */}
            {userToDelete && (
                <Modal show={showDeleteUserModal} onHide={() => setShowDeleteUserModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Deletion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete the user <strong>{userToDelete.username}</strong>?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="outline-secondary" onClick={() => setShowDeleteUserModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={() => handleUserDelete(userToDelete.id)}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <style jsx>{`
                .actbtn-grp {
                    display: flex;
                    gap: 6px;
                    flex-wrap: wrap;
                }
            `}</style>
        </div>
    );
};

export default UserManagementPage;
